var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-card',{staticClass:"omapi-statswidget__graph"},[_c('apexchart',{staticClass:"leads-chart",attrs:{"type":"area","width":"100%","height":"250px","options":_vm.chartOptions,"series":[
			{
				name: '',
				data: _vm.dates.values,
			},
		]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }